import React from "react";

/* Tiny ghosted preview of the booking screen (Singles · Doubles · 3D · 4D + A/B/C balls) — tells a new player "tap in and book like this" without noise. */
export const BookPeek = ({ className = "", tone = "light", testId = "book-peek" }) => {
  const pill = tone === "light" ? "bg-white/15 text-white/80 border-white/20" : "bg-slate-900/10 text-slate-700 border-slate-900/10";
  const on = tone === "light" ? "bg-amber-300 text-slate-900 border-amber-300" : "bg-blue-600 text-white border-blue-600";
  const ring = tone === "light" ? "border-white/60 text-white/80" : "border-slate-700/60 text-slate-700";
  return (
    <div className={`pointer-events-none select-none ${className}`} data-testid={testId} aria-hidden="true">
      <div className="flex items-center gap-0.5">
        {["Singles", "Doubles", "3D", "4D"].map((t, i) => <span key={t} className={`text-[7px] leading-none font-black px-1 py-[2px] rounded-full border ${i === 0 ? on : pill}`}>{t}</span>)}
      </div>
      <div className="mt-1 flex items-center gap-1">
        {["A", "B", "C"].map((b) => <span key={b} className={`w-4 h-4 rounded-full border-[1.5px] text-[7px] font-black flex items-center justify-center ${ring}`}>{b}</span>)}
        <span className={`ml-0.5 text-[7px] font-black px-1 py-[2px] rounded border ${tone === "light" ? "bg-red-500/80 text-white border-red-400/60" : "bg-red-100 text-red-700 border-red-200"}`}>ALL</span>
      </div>
    </div>
  );
};
